import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import classes from '@nerdwallet/base-styles/classes';
import {
  Button,
  List,
  Li,
  Title,
  Text,
  CenteredContainer,
} from '@nerdwallet/currency';
import HtmlToNDS from '@nerdwallet/react-html-to-nds';
import { getSlug } from '~/client/lib/department-utils';
import Hero from '../../employee-branding/hero/hero';
import { CAREERS_TEAMS_PATH } from '~/client/lib/employee-branding/careers-breadcrumbs-paths';
import grnhseTrackingCheck from '~/client/lib/company-content-src/grnhse-tracking-check';

import DepartmentMappings from '~/client/lib/company-content-src/department-mappings';

const CompanyJob = ({ job, location: routerLocation }) => {
  const { id, content, title, location } = job;
  const kebabCaseDepartment = getSlug(job.department);

  const mappedDepartment = DepartmentMappings[kebabCaseDepartment];

  return (
    <div>
      <Hero
        backgroundColor="#DDFDF2"
        title={mappedDepartment.name}
        copy={mappedDepartment.body}
        showCareerBreadcrumbs
        careerBreadcrumbLevel="3"
        careerBreadcrumbDepartment={job.department.name}
        imageUrlMobile={mappedDepartment.imageUrlMobile}
        imageUrlDesktop={mappedDepartment.imageUrlDesktop}
        jobTitle={title}
      />
      <div
        className={classNames([
          'job__hdr--cont',
          classes([
            'display-flex',
            'flex-direction-row',
            'justify-content-center',
            'margin-horizontal-3',
            'margin-horizontal-auto--wide',
            'align-items-baseline',
            'margin-vertical-4',
          ]),
        ])}
      >
        <div
          className={classNames(['job__hdr--left', classes('margin-right-3')])}
        >
          <Button
            default
            href={grnhseTrackingCheck(
              CAREERS_TEAMS_PATH,
              routerLocation.search
            )}
            className={classNames([
              'job__hdr--link',
              classes('color-nw-green'),
            ])}
          >
            All listings
          </Button>
        </div>
        <div
          className={classNames([
            'job__hdr--right',
            classes([
              'display-flex',
              'flex-direction-row',
              'align-items-baseline',
              'padding-left-3',
              'padding-left-0--wide',
            ]),
          ])}
        >
          <div className={classNames(['job__hdr--apply-desk'])}>
            <Button primary href="#applyJob">
              Apply now
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div
          className={classNames([
            'departments__description',
            classes([
              'margin-horizontal-auto',
              'text-align-center',
              'margin-bottom-4',
            ]),
          ])}
        >
          <Text>{location}</Text>
        </div>
      </div>
      <CenteredContainer
        key={id}
        className={classNames([
          'job__cont',
          classes('margin-horizontal-auto--wide'),
        ])}
      >
        <div>
          <Title
            size="small"
            className={classNames([
              'job__title',
              classes([
                'text-align-center',
                'margin-horizontal-3',
                'margin-horizontal-auto--wide',
                'margin-bottom-4',
              ]),
            ])}
            component="h2"
          >
            {title}
          </Title>
        </div>
        <div
          className={classNames([
            'job__content',
            classes([
              'text-small',
              'margin-horizontal-3',
              'margin-horizontal-auto--wide',
              'margin-bottom-5',
            ]),
          ])}
        >
          <HtmlToNDS
            html={content}
            decode
            componentDict={{
              h3: (node, children) => (
                <div className={classes(['margin-top-4', 'margin-bottom-3'])}>
                  <Text bold size="large" component="h3">
                    {children}
                  </Text>
                </div>
              ),
              p: (node, children) => (
                <div className={classes(['margin-bottom-3'])}>
                  <Text>{children}</Text>
                </div>
              ),
              ul: (node, children) => (
                <List
                  className={[
                    'job__content--list',
                    classes(['margin-bottom-3']),
                  ]}
                >
                  <Text size="default">{children}</Text>
                </List>
              ),
              li: (node, children) => <Li>{children}</Li>,
            }}
          />
        </div>
      </CenteredContainer>
    </div>
  );
};

CompanyJob.propTypes = {
  location: PropTypes.object,
  job: PropTypes.shape({
    id: PropTypes.string,
    content: PropTypes.string,
    title: PropTypes.string,
    location: PropTypes.string,
    department: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

CompanyJob.displayName = 'Company Job';

const CompanyJobWithRouter = withRouter(CompanyJob);

export default CompanyJobWithRouter;
